import commonStyles from "../commonStyles";
import React, {useEffect} from "react";
import {useSpring, animated} from "react-spring";
import {easings} from "@react-spring/web";

function CardRisultato(props) {
    const style = useSpring({ to: { opacity: 1, marginTop: 0 }, from: { opacity: 0, marginTop: -100 }, config: {easing: easings.easeOutBack }})

    return(
        <animated.div style={style}>
            <div className="card shadow-lg p-2 mb-5 bg-body rounded" style={ commonStyles.cardRisultato }>
                <div className="card-body">
                    <div style={{ textAlign: 'center' }}>
                        <h2 className="card-title text-capitalize">{ props.persona.nome }</h2>
                    </div>

                    <hr />

                    {props.persona.debito !== 0? <p className="card-text">Give To:</p> : <p className="card-text">Give:<br/>0$</p>}
                    {props.persona.to != null?
                        props.persona.to.map(aChi => (
                        <p className={"text-capitalize"}>{aChi.nome}: {aChi.daDare}$</p>
                        )) : <></>
                    }

                    <hr />


                    <p className="card-text">Recive:</p>
                    <p>{ props.persona.ricevere }$</p>
                </div>
            </div>
        </animated.div>
    );
}

export default CardRisultato